export default __webpack_public_path__ + "static/media/ico-uniformes.ac1415ac.svg";